'use client';

import { SessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';

export default function AuthProvider({ children }: { children: ReactNode }) {
  return (
    <SessionProvider data-component-id="src/components/providers/AuthProvider.tsx:8:4" data-component-path="src/components/providers/AuthProvider.tsx" data-component-line="8" data-component-end-line="10" data-component-file="AuthProvider.tsx" data-component-name="SessionProvider" data-component-content="%7B%22elementName%22%3A%22SessionProvider%22%7D" refetchInterval={15} refetchOnWindowFocus>
      {children}
    </SessionProvider>
  );
}
